var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#fff",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M20.219 7.878a2.15 2.15 0 0 0-1.511-1.51C17.366 6 12 6 12 6s-5.367 0-6.708.353c-.72.198-1.313.79-1.511 1.525-.353 1.342-.353 4.124-.353 4.124s0 2.796.353 4.124a2.15 2.15 0 0 0 1.51 1.51c1.357.368 6.709.368 6.709.368s5.366 0 6.708-.353a2.15 2.15 0 0 0 1.511-1.511c.353-1.342.353-4.124.353-4.124s.014-2.796-.353-4.138"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m10.291 14.572 4.463-2.57-4.463-2.57z"
})));
export default SvgYoutube;